import React from "react"
import Form from "./Form.js"
import {usePartOrderData} from "../../hooks/usePartOrderData";
import {useSelector} from "react-redux";
import {getDataFresh} from "../../state/selectors";
import {useDepartmentsData} from "../../hooks/useDepartmentsData";
import {useDefaultsData} from "../../hooks/useDefaultsData";
import {useTrackingOptionsData} from "../../hooks/useTrackingOptionsData";
import Nav from "../Nav/Nav";
import {useParams} from "react-router-dom";



export default function PartOrderForm(props){
    let dataFresh = useSelector(getDataFresh);
    const {partorder} = useParams()
    let partOrderLoaded = usePartOrderData(partorder, dataFresh);
    let departmentsLoaded = useDepartmentsData({}, dataFresh);
    let appDefaultsLoaded = useDefaultsData({});
    let trackingOptionsLoaded = useTrackingOptionsData({}, dataFresh);
    return (
        <div>
            <Nav/>
            <Form
                loaded={partOrderLoaded && departmentsLoaded && appDefaultsLoaded && trackingOptionsLoaded}
                endpoint={props.endpoint}
                history={props.history}
            />
        </div>
    )
}